module.exports = __webpack_public_path__ + "static/media/hide_nav_icon_green.36f0aa41.svg";